<template>
  <div class="w-10/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack">
        Gestión de CIF
      </h1>
      <div class="flex flex-row items-center">
        <!--<div class="flex flex-row bg-white items-center justify-center px-4 w-48 h-10 box-border text-costeaGray text-t14 rounded-md">
          <i class="ri-search-line mx-2"></i>
          <input type="text" name="search_cat" id="search_cat" class="w-40 outline-none pr-2" placeholder="Busca una categoría">
        </div>-->
        <div v-if="cifs.length>0" class="flex bg-white p-2 mr-2 rounded-md costeaBlueGradient"><p class="text-white mr-2 ml-2">{{`COP $ ${interNumberFormat(calcTotalCost)}`}}</p></div>

        <div class="flex flex-row justify-center items-center mx-2">
          <select v-model="filtroOrden" class="text-costeaGray px-2 py-1 rounded-md mx-2 text-base text-t14 h-10">
            <option value="0">Ordenar por:</option>
            <option value="1">Menor a mayor</option>
            <option value="2">Mayor a menor</option>
          </select>
        </div>

        <p class="text-costeaGray ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{page}}</span> de <span>{{getPageNumber()}}</span>
        </p>
        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50" @click="page--, getPageNumber()" v-if="page != 1"><i class="ri-arrow-left-line"></i></button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()" v-show="page < getPageNumber()"><i class="ri-arrow-right-line"></i></button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-5">
      <div class="col-start-1 col-end-13 bg-white p-6 rounded-md">
                <thead class="h-10 flex flex-row items-center font-costea text-t14 border-b-2">
                  <th class="text-costeaDarkGray w-4/12 px-2 text-left">Nombre del CIF</th>
                  <th class="text-costeaDarkGray w-4/12 px-2 text-left">Costo</th>
                </thead>
                <tbody v-for="cif in displayedCIF" :key="cif.index"
                 class="h-14 flex flex-row items-center font-costea text-t14 border-b-2 border-gray-100 hover:bg-costeaContainer">
                  <td @click="showModalEdit(cif.nombre_costo, cif.id, cif.costo_mensual)" class="hover:underline px-2 cursor-pointer text-costeaGray w-4/12">{{cif.nombre_costo}}</td>
                  <td @click="showModalEdit(cif.nombre_costo, cif.id, cif.costo_mensual)" class="hover:underline px-2 cursor-pointer text-costeaGray w-4/12">$ {{interNumberFormat(cif.costo_mensual)}}</td>
                  <td class="flex ml-auto w-4/12 justify-end">
                    <button @click="showModalDelete(cif.nombre_costo, cif.id,cif.costo_mensual)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaDarkSalmon h-6 w-6 rounded-full flex justify-center items-center"><i class="ri-delete-bin-6-line"></i></button>
                    <button @click="showModalEdit(cif.nombre_costo, cif.id, cif.costo_mensual)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaPrimaryDisabled hover:text-costeaPrimary h-6 w-6 rounded-full flex justify-center items-center"><i class="ri-edit-line"></i></button>
                  </td>
                </tbody>
              </div>

    </div>

    <transition name="page">
      <component :cifOld="editName" :idCif="parseInt(editId)" @closeModalEdit="handleEditCifCloseModal" @reloadData="reloadData"  v-show="this.modalEditActive" :is="editModal"/>
    </transition>

    <transition name="page">
      <component :cifOld="deleteName" :idCif="parseInt(deleteId)" @closeModalDelete="handleDeleteCifCloseModal" @reloadData="reloadData"  v-show="this.modalDeleteActive" :is="deleteModal"/>
    </transition>

    <transition name="page">
      <component @closeModalAdd="handleAddCifCloseModal" @reloadData="reloadData"  v-show="this.modalActive" :is="selected"/>
    </transition>

    <buttonAdd @showModal="handleShowCif"/>
    
  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios'
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import AddCif from '@/components/cif/AddCif.vue' 
import editCif from '@/components/cif/EditCif.vue' 
import deleteCif from '@/components/cif/DeleteCif.vue' 

export default{
  name: "Cif",
  components:{
    buttonAdd,
    AddCif,
    editCif,
    deleteCif
  },
  data(){
    return{
      cifs: [],
      page: 1,
      pages:[],
      elementsPerPage: 8,
      modalActive : false,
      selected: 'AddCif',
      editName: '',
      editId:0,
      deleteName: '',
      deleteId:0,
      modalEditActive: false,
      modalDeleteActive: false,
      filtroOrden: '0'
    }
  },
  computed:{
    ...mapState(['costea']),

    calcTotalCost(){
      let total = 0;
      this.cifs.forEach(element => {
       return total += Number(element.costo_mensual);
      });
      return total.toFixed(2);
    },

    displayedCIF(){
        if(this.filtroOrden == ""){
          return this.paginate(this.cifs)
        }
        else{
          return this.paginate(this.ordenar)
        }
    },

    editModal(){
        if(this.modalEditActive){
          return 'editCif'
        }else{
          return ''
        }
    },

    deleteModal(){
        if(this.modalDeleteActive){
          return 'deleteCif'
        }else{
          return ''
        }
      },
      ordenar(){
        let data = this.cifs
        if(this.filtroOrden == '0'){
          data.sort((a, b) => a.id - b.id)
        }
        //ordenar de menor a mayor y mayor a menor del costo_total_del_area
        if(this.filtroOrden == '1'){
          //ordernar de menor a mayor el costo_total_del_area
          data.sort((a, b) => a.costo_mensual - b.costo_mensual)
        }
        if(this.filtroOrden == '2'){
          //ordenar de mayor a menor el costo_total_del_area
          data.sort((a, b) => b.costo_mensual - a.costo_mensual)
        }
        return data
      },
    },
  methods:{
    interNumberFormat(number){
            let interNF = new Intl.NumberFormat('es-CO');
            let numberDecimals = parseFloat(number)
            numberDecimals = numberDecimals.toFixed(2)
            return interNF.format(numberDecimals)
    },
    handleShowCif(value){
        this.modalActive = value
    },
    handleAddCifCloseModal(value){
        this.modalActive = value
    },
    handleEditCifCloseModal(value){
        this.modalEditActive = value
    },
    handleDeleteCifCloseModal(value){
        this.modalDeleteActive = value
    },
     showModalEdit(cifNombre, cifId, cifCosto){
        if(this.modalEditActive === false){
            this.modalEditActive = true
            this.editName = cifNombre
            this.editCosto = cifCosto
            this.editId = parseInt(cifId)
        }else{
          this.modalEditActive = false
        }
      },
      showModalDelete(cifNombre, cifId){
        if(this.modalDeleteActive === false){
            this.modalDeleteActive = true
            this.deleteName = cifNombre
            this.deleteId = parseInt(cifId)
        }else{
          this.modalDeleteActive = false
        }
      },
    getCifs: function(){
          axios
          .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}cif`)
            .then( respuesta => {
                if(respuesta.data.status == false){
                  this.$router.push('/login')
                }
                this.cifs = respuesta.data;
                this.pages = []
                this.setPages()
                console.log(this.cifs)
            }).catch((error) => {
            if(error){
              if(error.status === 401){
                this.$router.push('/login')
              }
            }
        })
    },
    reloadData(value){
      if(value === true){
        this.getCifs()
        value = false
      }else{
        console.log('Ocurrio un error')
      }
    },
    setPages(){
        let numberOfPages = Math.ceil(this.cifs.length / this.elementsPerPage);
        for (let index = 1; index <= numberOfPages; index++) {
          this.pages.push(index);
        }
    },
    paginate(category) {
          let page = this.page;
          let perPage = this.elementsPerPage;
          let from = (page * perPage) - perPage;
          let to = (page * perPage);
          return  category.slice(from, to);
    },
    getPageNumber(){
          return this.pages.length
    }
  },
  beforeMount(){
      if(localStorage.getItem('token')){
        this.getCifs()
      }else{
        this.$router.push('/login')
      }
      
    },
}


</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
</style>